import React, { useEffect } from 'react';
import { useQuery } from "@apollo/client";
import { gql } from "apollo-boost";

import { useAppState } from "../../contexts/AppContext";
import { retrieveValue } from "../../includes/localStorage";

const Localisation: React.FC = () => {
    const [, setAppState] = useAppState();

    const { data } = useQuery(GET_LOCALISED_COUNTRY);

    useEffect(
        () => {
            data && setAppState((prev: any) => ({
                country: {
                    ...prev.country,
                    code: retrieveValue("selected-country")?.replace(/"/g, "") ||
                        data.getLocalisedCountry.countryCode,
                    codeFromIP: data.getLocalisedCountry.countryCodeFromIp,
                }
            }));
        },
        [data, setAppState]
    );

    return null;
};

const GET_LOCALISED_COUNTRY = gql`
    query getLocalisedCountry {
        getLocalisedCountry {
            countryCode
            countryCodeFromIp
            title
        }
    }
`;

export default Localisation;
